// import 'chosen-js';
import Cookies from 'js-cookie';
import './helpers/browser-detect';
import './helpers/jquery.extends';
import './helpers/additionalProductInfo';
import './helpers/debounce';
import './helpers/storage';
import './helpers/mustache';
import './helpers/vtex-masterdata';
import './helpers/events';
// import './helpers/validation';
import './helpers/loader';
import './helpers/format';
import './helpers/url';
import './helpers/inputMask';
import './helpers/vtex-FixMarketingDataByUtmSource';

import './helpers/text';

window.Cookies = Cookies;

window.storeTheme.helpers.FixMarketingDataByUtmSource();

export {};
